'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _class = function () {
  /** @param {HTMLElement} element */
  function _class(element) {
    (0, _classCallCheck3.default)(this, _class);

    this.element = element;
    this.submitButtons = (0, _functional.getElements)('[data-el="product-upsell.submit"]', {
      content: element
    });

    this.setupListeners();
  }

  (0, _createClass3.default)(_class, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      this.submitButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          return _this.addToCart();
        });
      });
    }
  }, {
    key: 'addToCart',
    value: function addToCart() {
      window.drawers.activeDrawerKey = 'cart';
      window.PushCart.addItem(this.variantId, {
        quantity: 1,
        properties: this.variantProperties
      });
    }
  }, {
    key: 'variantId',
    get: function get() {
      return Number(this.element.dataset.variantId);
    }
  }, {
    key: 'variantProperties',
    get: function get() {
      return JSON.parse(this.element.dataset.variantProperties);
    }
  }]);
  return _class;
}();

exports.default = _class;